class PromoPopup extends HTMLElement {
  constructor() {
    super();

    // Prevent popup on Shopify robot challenge page
    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'beyours:promo-popup';

    this.classes = {
      bodyClass: 'promo-popup--open',
      activeClass: 'is-active',
      closingClass: 'is-closing',
      showImage: 'show-image',
      imageReady: 'image-ready',
    };

    this.popup = this.querySelector('.promo-popup');

    // Open modal if errors or success message exist
    if (this.querySelector('.form__message')) {

      // 如果是黑五活动或世界杯投票，不显示弹窗
      if (window.isBlackFriday || window.isWorldcupVote) {
        return;
      }
      this.open();
    }

    this.querySelectorAll('.popup-close, .popup-overlay').forEach((button) => {
      button.addEventListener('click', this.close.bind(this));
    });

    this.querySelectorAll('.popup-open').forEach((button) => {
      button.addEventListener('click', this.open.bind(this));
    });

    if (!this.getCookie(this.cookieName) || this.dataset.testMode === 'true') {
      this.init();
    }

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => filterShopifyEvent(event, this, () => this.open.bind(this)));
      document.addEventListener('shopify:section:select', (event) => filterShopifyEvent(event, this, this.open.bind(this)));
      document.addEventListener('shopify:section:deselect', (event) => filterShopifyEvent(event, this, this.close.bind(this)));
    }
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    // 如果是黑五活动，不显示弹窗
    if (window.isBlackFriday || window.isWorldcupVote) {
      return;
    }

    setTimeout(
      function () {
        this.open();
      }.bind(this),
      parseInt(this.dataset.delay) * 1000
    );
  }

  open() {
    document.body.classList.remove(this.classes.bodyClass);
    this.clearImageReadyTimer();
    this.popup.classList.remove(this.classes.imageReady);
    this.popup.classList.add(this.classes.activeClass);
    this.showImageTimer = setTimeout(() => {
      this.popup.classList.add(this.classes.showImage);
      this.imageReadyTimer = setTimeout(() => {
        this.popup.classList.add(this.classes.imageReady);
      }, 500);
    }, 600);

    if (this.dataset.position === 'center') {
      setScrollbarWidth();
      document.body.classList.add(this.classes.bodyClass);
    }
  }

  close() {
    this.clearImageReadyTimer();
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      this.popup.classList.remove(this.classes.showImage);
      this.popup.classList.remove(this.classes.imageReady);

      if (this.dataset.position === 'center') {
        document.body.classList.remove(this.classes.bodyClass);
      }
    }, 500);

    // Remove a cookie in case it was set in test mode
    if (this.dataset.testMode === 'true') {
      this.removeCookie(this.cookieName);
      return;
    }

    this.setCookie(this.cookieName, this.dataset.expiry);
  }

  clearImageReadyTimer() {
    if (this.showImageTimer) {
      clearTimeout(this.showImageTimer);
      this.showImageTimer = null;
    }

    if (this.imageReadyTimer) {
      clearTimeout(this.imageReadyTimer);
      this.imageReadyTimer = null;
    }
  }

  getCookie(name) {
    const match = document.cookie && document.cookie?.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return match ? match[2] : null;
  }

  setCookie(name, expiry) {
    document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`;
  }

  removeCookie(name) {
    document.cookie = `${name}=; max-age=0`;
  }
}
customElements.define('promo-popup', PromoPopup);
